/* global BigInt */
import {guidedPool} from "./guidedTeamAnalysis";
// Deterministic evidence signature for repeat detection, never an authorization token.
function canonical(value) {
  if (Array.isArray(value)) return value.map(canonical);
  if (value && typeof value === "object") return Object.fromEntries(Object.keys(value).sort().map(k => [k, canonical(value[k])]));
  return value;
}
export function evidenceSignature(value) {
  const text = JSON.stringify(canonical(value));
  // Two independent 64-bit rolling checksums keep receipts small. Retain length.
  const mask = (1n << 64n) - 1n;
  let a = 14695981039346656037n, b = 7809847782465536322n;
  for (let i = 0; i < text.length; i++) {
    const c = BigInt(text.charCodeAt(i));
    a = ((a ^ c) * 1099511628211n) & mask;
    b = ((b ^ c) * 14029467366897019727n) & mask;
  }
  return JSON.stringify({version:1,length:text.length,checksum:a.toString(16).padStart(16,'0')+b.toString(16).padStart(16,'0')});
}
export function reassessmentIdentity(data, id, configuration) {
  const games = guidedPool(data, id).map(g => ({id:g.id, kickoff:g.kickoff, home:g.home_team_id, away:g.away_team_id, goals:g.goals, result:g.result, statistics:g.statistics, statistics_model:g.statistics_model, should:g.should, market:g.market, conversion:g.conversion, external_xgoals:g.external_xgoals}));
  const history = data.history?.teams?.find(t => Number(t.team_id) === Number(id));
  return {evidence:evidenceSignature({league:data.league_id, season:data.season?.id, games, history, transitions:data.transitions}), configuration:JSON.stringify(canonical(configuration))};
}
export function sameAssessment(record, identity) {
  return record?.version === 1 && record.evidence === identity.evidence && record.configuration === identity.configuration;
}
export function assessmentEdit(id, record) {
  return {team_id:Number(id), group:"reassessment", field:"record", value:1, record};
}
